package fr.frux.core.designsystem.components

import androidx.compose.foundation.clickable
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.PhotoCamera
import androidx.compose.material.icons.outlined.PhotoLibrary
import androidx.compose.material3.Icon
import androidx.compose.material3.ListItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.resources.Res
import fr.frux.core.designsystem.resources.ds_photo_source_camera
import fr.frux.core.designsystem.resources.ds_photo_source_gallery
import org.jetbrains.compose.resources.stringResource

/**
 * Choix de la source d'une photo (appareil ou galerie), partagé par la fiche et l'assistant.
 * Sans dépendance à `core-media` : l'appelant traduit le choix vers sa propre source d'image.
 */
@Composable
fun FruxPhotoSourceSheet(
    onCamera: () -> Unit,
    onGallery: () -> Unit,
    onDismiss: () -> Unit,
) {
    FruxModalBottomSheet(onDismiss = onDismiss) {
        ListItem(
            headlineContent = { Text(stringResource(Res.string.ds_photo_source_camera)) },
            leadingContent = { Icon(Icons.Outlined.PhotoCamera, contentDescription = null) },
            modifier = Modifier.clickable(onClick = onCamera),
        )
        ListItem(
            headlineContent = { Text(stringResource(Res.string.ds_photo_source_gallery)) },
            leadingContent = { Icon(Icons.Outlined.PhotoLibrary, contentDescription = null) },
            modifier = Modifier.clickable(onClick = onGallery),
        )
    }
}
